import { InputRule } from '@tiptap/core'
import { DATAFIELD_PATTERN, SUBTEMPLATE_PATTERN } from '../utils/processContent'

export const EditableInputRule = {
  // Add input rules via an extension
  name: 'inputRule',
  addInputRules() {
    // Rule needs access to the editor's schema to find node types
    const dfNodeType = this.editor.schema.nodes.dfNode
    const stNodeType = this.editor.schema.nodes.stNode
    const rules = []

    // Simplified Regex matching only one type at a time
    if (dfNodeType) {
      rules.push(
        new InputRule({
          find: DATAFIELD_PATTERN,
          handler: ({ state, range, match }) => {
            const rawPath = match[1]
            const trimmedPath = rawPath.trim()
            state.tr.replaceWith(
              range.from,
              range.to,
              dfNodeType.create({ dfName: trimmedPath })
            )
          }
        })
      )
    }
    if (stNodeType) {
      rules.push(
        new InputRule({
          find: SUBTEMPLATE_PATTERN,
          handler: ({ state, range, match }) => {
            const rawName = match[1]
            const trimmedName = rawName.trim()
            state.tr.replaceWith(
              range.from,
              range.to,
              stNodeType.create({ stName: trimmedName })
            )
          }
        })
      )
    }
    return rules
  }
}
